import React, { useEffect, useState } from "react"
import { HamburgerSqueeze } from "react-animated-burgers"
import { useLocation } from "@reach/router"
import logo from "src/assets/logo-mobile.png"
import { Link } from "gatsby"

import Chapters from "src/components/mobile/_layout/chapters"
import LanguageSelector from "src/components/mobile/_layout/languageSelector"

import { HeaderContainer, FlexWrapper, LogoLink } from "./styles"

const Header = ({ routes, currentRoute }) => {
  const [menuVisible, setMenuVisible] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    pathname && setMenuVisible(false)
  }, [pathname])

  return (
    <>
      <HeaderContainer>
        <FlexWrapper>
          <HamburgerSqueeze
            buttonWidth={30}
            barColor="#f2efe4"
            isActive={menuVisible}
            toggleButton={() => setMenuVisible(prev => !prev)}
            style={{ transform: "scale(0.75)", alignSelf: "center" }}
          />
          <LogoLink to="/">
            <img src={logo} alt="Logo" />
          </LogoLink>
          <LanguageSelector hide={false} path={pathname} />
        </FlexWrapper>
      </HeaderContainer>
      <Chapters
        isVisible={menuVisible}
        currentRoute={currentRoute}
        routes={routes}
      />
    </>
  )
}

export default Header
